import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20fashion%20product%20arrangement%20on%20warm%20cream%20linen%20background%2C%20curated%20selection%20of%20sneakers%2C%20hoodies%2C%20designer%20bags%2C%20accessories%2C%20and%20caps%20arranged%20in%20artistic%20composition%2C%20soft%20natural%20window%20light%20from%20left%20side%20casting%20gentle%20shadows%2C%20warm%20terracotta%20and%20beige%20tones%2C%20editorial%20product%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20clean%20minimal%20aesthetic%2C%20high-end%20catalog%20look%20with%20carefully%20styled%20product%20placement&width=1600&height=900&seq=hero-product-collage-01&orientation=landscape"
          alt="Curated product collection for Basetao Spreadsheet shopping research"
          className="w-full h-full object-cover"
          title="Basetao Spreadsheet - Curated Product Research Collection"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/28 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-32">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold tracking-wide uppercase mb-6">
            Updated for 2026
          </span>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            Basetao Spreadsheet 2026: The Ultimate Product Research & Shopping Database
          </h1>

          <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-8 max-w-xl">
            Find, compare, and organize the best products with our complete Basetao Spreadsheet guides. Explore product categories, QC information, shipping tips, discount strategies, and expert reviews in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2"
            >
              <span>Basetao Spreadsheet</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line text-sm"></i>
              </div>
            </a>
            <Link
              to="/shopping-guide"
              className="px-6 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 text-sm font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
            >
              Explore Shopping Guide
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}